import HTTP from "../api/webportal";

const URL = 'api/accounts';

class DataService {
    getAll() {
        return HTTP.get(`/${URL}`);
    }

    get(id) {
        return HTTP.get(`/${URL}/${id}`);
    }

    create(data) {
        return HTTP.post(`/${URL}`, data);
    }

    update(id, data) {
        return HTTP.put(`/${URL}/${id}`, data);
    }

    delete(id) {
        return HTTP.delete(`/${URL}/${id}`);
    }

    find(find, search) {
        return HTTP.get(`/${URL}?${find}=${search}`);
    }
}

export default new DataService();